import React, { useContext, useEffect, useRef, useState } from 'react';
import './Header.css';
import { FormattedMessage } from 'react-intl';
import { TopicContext } from '../../context/topicContext';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withOrientationChange } from 'react-device-detect';
import { headerFadeoutDuration } from '../../constants';
import { tracking, tagType } from '../../utils/tracking';
import { messages } from '../../messages';

const Header = ({ isLandscape }) => {
  const { currentTopic, initialOverview } = useContext(TopicContext);
  const [topicIndex, setTopicIndex] = useState(currentTopic);
  const [animating, setAnimating] = useState(false);
  const [overviewState, setOverviewState] = useState(true);

  // ref for storing timeout when header text should fade in/out
  let timeoutRef = useRef();

  useEffect(() => {
    // If not same topic start by clearing timeout, maybe the user has clicked back and forth quickly without the timer ended.
    if (currentTopic !== topicIndex) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Start animating, meaning fading out the text.
      setAnimating(true);

      // Set a timeout, same duration as the css transition, (remember subtitle has 100ms delay)
      // And set animating to false, meaning fade new/updated text in.
      timeoutRef.current = setTimeout(() => {
        setOverviewState(initialOverview);
        setTopicIndex(currentTopic);
        setAnimating(false);
      }, headerFadeoutDuration);
    }
  }, [initialOverview, currentTopic, topicIndex]);

  useEffect(() => {
    tracking(tagType.pageView, messages.topicOverviewTitle.defaultMessage);
  }, []);

  // Set animating class, if initialOverview and if landscape
  const topicHeaderClassNames = classNames('topics-header', {
    animating,
    initialOverview: overviewState,
    isLandscape,
  });

  return (
    <div className={topicHeaderClassNames}>
      <h2 className="ibm-plex-sans-regular title">
        <FormattedMessage
          id={`topic.topic${
            topicIndex === undefined ? 'Overview' : topicIndex
          }Title`}
        />
      </h2>
      <div className="ibm-plex-sans-regular sub-title">
        <FormattedMessage
          id={`topic.topic${
            topicIndex === undefined ? 'Overview' : topicIndex
          }SubTitle`}
        />
      </div>
    </div>
  );
};

Header.displayName = 'Header';

Header.propTypes = {
  // messages: PropTypes.object,
  isLandscape: PropTypes.bool,
};

export default withOrientationChange(Header);
